import { FC } from 'react'
import { NonUndefined } from 'react-hook-form'

import LoadingButton from '@/components/loading-button'
import { ActionTimer } from '@/hooks/useActionTimer'
import { Logging } from '@/out/logging'
import { Label } from '@/components/ui/label'

type Props = {
  configuration: NonUndefined<Logging['cloudwatch']>
  timer: ActionTimer
  onRemove: () => void
}

const CloudwatchDetails: FC<Props> = ({ configuration, timer, onRemove }) => {
  return (
    <>
      <div className="pt-2 mb-6 space-y-3">
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Access Key ID:</Label>
          <span className="text-sm font-medium">{configuration.accessKeyId}</span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Region:</Label>
          <span className="text-sm font-medium">{configuration.region}</span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Log Group:</Label>
          <span className="text-sm font-medium">{configuration.logGroup}</span>
        </div>
      </div>
      <LoadingButton timer={timer} size="sm" onClick={onRemove} variant="outline-destructive">
        Disconnect
      </LoadingButton>
    </>
  )
}

export default CloudwatchDetails
